import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button, Col, Link } from '../components'
import { useIsBulkOrderEnabled } from './useIsBulkOrderEnabled'

const BulkOrderListButton = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const isBulkOrderEnabledForUser = useIsBulkOrderEnabled()

  if (!isBulkOrderEnabledForUser) {
    return null
  }

  return (
    <Col>
      <Button
        leftIcon="MdAdd"
        iconSize={23}
        large
        primary
        onClick={() => navigate(Link.BULK_ORDER)}
      >
        {t('New bulk order')}
      </Button>
    </Col>
  )
}

export default BulkOrderListButton
